import { Component, OnInit, OnDestroy } from "@angular/core";
import { ServerCartItem } from "../model/cart.model";
import { CartService } from "../services/cart.service";
import { debounceTime } from "rxjs";
import { SessionApi } from "../api/session.api";

@Component({
  selector: "app-mini-cart-toast",
  templateUrl: "./mini-cart-toast.component.html",
  styleUrls: ["./_mini-cart-toast.component.scss"],
})
export class MiniCartToastComponent implements OnInit, OnDestroy {
  item: ServerCartItem | null = null;
  visible = false;

  private timeoutRef: any;

  progressKey = 0;
  customerId!: number;

  constructor(
    public cartService: CartService,
    private session: SessionApi,
  ) {
    this.session.$customerData.subscribe((customer) => {
      if (customer && customer.id) {
        this.customerId = customer.id;
      }
    });
  }

  ngOnInit(): void {
    this.cartService.miniCart$.subscribe((item) => {
      if (!item) return;

      if (this.timeoutRef) {
        clearTimeout(this.timeoutRef);
      }

      this.visible = false;

      setTimeout(() => {
        this.item = item;
        window.scroll(0, 0);

        this.visible = true;

        this.progressKey++;

        this.timeoutRef = setTimeout(() => {
          this.visible = false;
          this.item = null;
          this.cartService.miniCart$.next(null);
        }, 5000);
      }, 50);
    });
  }

  close() {
    this.visible = false;
    this.item = null;

    if (this.timeoutRef) {
      clearTimeout(this.timeoutRef);
    }

    this.cartService.miniCart$.next(null);
  }

  deleteCartItem(item: ServerCartItem) {
    this.cartService
      .deleteCartItem(this.customerId, item.id)
      .pipe(debounceTime(1000))
      .subscribe(() => {
        this.cartService.removeCartItemById(item.id);
        this.close();
      });
  }

  ngOnDestroy(): void {
    if (this.timeoutRef) {
      clearTimeout(this.timeoutRef);
    }
  }
}
